import { Bell, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePushNotifications } from '../../hooks/usePushNotifications';

export default function PushNotificationBanner() {
  const { supported, permission, subscribed, loading, subscribe } = usePushNotifications();
  const [dismissed, setDismissed] = useState(false);

  if (!supported || dismissed || permission !== 'default' || subscribed) {
    return null;
  }

  return (
    <div className="bg-primary-50 dark:bg-primary-900/30 border-b border-primary-200 dark:border-primary-800">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-start sm:items-center gap-2 min-w-0">
          <Bell className="h-5 w-5 text-primary-600 dark:text-primary-400 shrink-0 mt-0.5 sm:mt-0" />
          <p className="text-sm text-primary-900 dark:text-primary-100">
            <span className="font-medium">Enable notifications</span>
            {' — '}
            Get alerts for friend requests and messages when this tab is in the background.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0 pl-7 sm:pl-0">
          <button
            type="button"
            onClick={() => subscribe()}
            disabled={loading}
            className="btn-primary text-sm py-1.5 px-3"
          >
            {loading ? 'Enabling…' : 'Enable'}
          </button>
          <Link
            to="/profile"
            className="text-sm text-primary-700 dark:text-primary-300 hover:underline py-1.5 px-2"
          >
            Settings
          </Link>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="p-1.5 rounded-md text-primary-600 dark:text-primary-400 hover:bg-primary-100 dark:hover:bg-primary-800/50"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
